// Polar product IDs - update these when switching from sandbox to production
export const POLAR_PRODUCTS = {
  pro_monthly: "cf616368-6978-4053-9767-425b15eea34c",
  pro_yearly: "cb2d9f74-df90-4363-b524-10ab9ccd8a04",
  team: "b3ce1ed1-4bb1-47d7-b94c-c935f7ee02bb",
} as const;

// Polar environment - change to "production" when going live
export const POLAR_ENV = "sandbox" as const;
